module.exports = __webpack_public_path__ + "img/logo.60d0bb6.60d0bb6d.svg";